import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	reportingLinesEmptyStateContainer: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'space-around',
		width: '100%',
		paddingTop: token('space.600', '48px'),
		paddingRight: token('space.250', '20px'),
		paddingBottom: token('space.600', '48px'),
		paddingLeft: token('space.250', '20px'),
	},
	reportingLinesEmptyStateContent: {
		marginTop: token('space.150', '12px'),
		marginBottom: token('space.150', '12px'),
	},
	reportingLinesEmptyStateImage: {
		marginTop: token('space.150', '12px'),
		marginBottom: token('space.150', '12px'),
	},
	reportingLinesEmptyStateHeading: {
		font: token('font.heading.medium'),
	},
	infoMessage: {
		marginBottom: token('space.250', '20px'),
	},
});

export const ReportingLinesEmptyStateContainer = ({
	children,
	testId,
}: {
	children: React.ReactNode;
	testId?: string;
}): React.JSX.Element => {
	return (
		<Box xcss={styles.reportingLinesEmptyStateContainer} testId={testId}>
			{children}
		</Box>
	);
};

export const ContentSection = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
	return <Box xcss={styles.reportingLinesEmptyStateContent}>{children}</Box>;
};

export const InfoMessage = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
	return <Box xcss={styles.infoMessage}>{children}</Box>;
};
